// extracted by mini-css-extract-plugin
module.exports = {"popup":"styles_popup__7x4oa","popUpIcon":"styles_popUpIcon__2e9N0"};